<div class="acct-operation-panel">
  <h5 class="acct-operation-panel__title text-uppercase">TRIGGERS</h5>

  @if (accountingOperation?.triggers?.length > 0) {
    @for (trigger of accountingOperation.triggers; track trigger; let first = $first) {
      @if (!first) {
        <strong class="d-block py-2 px-1">AND</strong>
      }
      <rl-accounting-operation-trigger [anchorTemplateId]="anchorTemplateId" [trigger]="trigger">
      </rl-accounting-operation-trigger>
    }
  } @else {
    <div class="rounded d-flex align-items-center p-3 alert alert-warning" role="alert">
      <div class="text-center">No Triggers Configured.</div>
    </div>
  }

  <h5 class="acct-operation-panel__title text-uppercase mt-4">EVENTS</h5>

  @if (accountingOperation?.events?.length > 0) {
    @for (event of accountingOperation.events; track event; let first = $first) {
      @if (!first) {
        <strong class="d-block p-2 pt-1">OR</strong>
      }
      <rl-account-operation-event [anchorTemplateId]="anchorTemplateId" [event]="event"
        [hasCostAllocation]="hasCostAllocation" [hasCostAllocationTemplate]="hasCostAllocationTemplate">
      </rl-account-operation-event>
    }
  } @else {
    <div class="rounded d-flex align-items-center p-3 alert alert-warning" role="alert">
      <div class="text-center">No Events Configured.</div>
    </div>
  }

  <ng-container *rlFeatureEnabled="featureKeys.AccountingProcessPhaseTwo">
    <h5 class="acct-operation-panel__title text-uppercase mt-4">DATE POPULATION</h5>

    @if (accountingOperation?.dates?.length > 0) {
      @for (date of accountingOperation.dates; track date; let first = $first) {
        @if (!first) {
          <strong class="d-block p-2 pt-1">AND</strong>
        }
        <rl-accounting-operation-date [anchorTemplateId]="anchorTemplateId" [date]="date"
          [datesDictionary]="datesDictionary">
        </rl-accounting-operation-date>
      }
    } @else {
      <div class="rounded d-flex align-items-center p-3 alert alert-warning" role="alert">
        <div class="text-center">No Dates Configured.</div>
      </div>
    }
  </ng-container>
</div>



